module.exports = __webpack_public_path__ + "static/card-53124a2ad0ee9bec8f4300e656d8f108.jpg";